import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AccessDeniedService {
  readonly show = signal(false);

  trigger(): void {
    this.show.set(true);
  }

  dismiss(): void {
    this.show.set(false);
  }
}
